'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _T = require('ramda/src/T');

var _T2 = _interopRequireDefault(_T);

var _always = require('ramda/src/always');

var _always2 = _interopRequireDefault(_always);

var _equals = require('ramda/src/equals');

var _equals2 = _interopRequireDefault(_equals);

var _cond = require('ramda/src/cond');

var _cond2 = _interopRequireDefault(_cond);

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// (props, { x, y }) => nextProps
var mapShapePropsByDiff = function mapShapePropsByDiff(props, diff) {
  return (0, _cond2.default)([[(0, _equals2.default)('circle'), (0, _always2.default)({
    cx: props.cx + diff.x,
    cy: props.cy + diff.y
  })], [(0, _equals2.default)('polygon'), function () {
    return {
      points: props.points.split(' ').map(function (point) {
        var _point$split = point.split(','),
            _point$split2 = _slicedToArray(_point$split, 2),
            x = _point$split2[0],
            y = _point$split2[1];

        return Number(x) + diff.x + ',' + (Number(y) + diff.y);
      }).join(' ')
    };
  }], [_T2.default, (0, _always2.default)({
    x: props.x + diff.x,
    y: props.y + diff.y
  })]])(props.tagName);
};

exports.default = mapShapePropsByDiff;
module.exports = exports['default'];